<template>
    <section v-if="getCampanha">
        <div class="card__container">

            <h3 v-if="nextCall.nome"> {{ nextCall.nome }}</h3>
            <div class="contatos">
                <h6 v-if="nextCall.telefone" @click="ligar(nextCall.telefone)" class="call"> {{ nextCall.telefone }}  <i class="fas fa-phone"></i></h6>
                <h6 v-if="nextCall.telefone_2" @click="ligar(nextCall.telefone_2)" class="call"> {{ nextCall.telefone_2 }}  <i class="fas fa-phone"></i></h6>
            </div>

            <p v-if="nextCall.telefone"> Alguma Informação extra que pode ser inserida </p>
            <p v-else> No Momento não possuí nenhuma campanha </p>

            <div class="card__button">
                <h3> {{ getTime() }}  <i class="fas fa-angle-down info-pointer"  :class="[{infoClicked: isInfo}]" @click="info"></i></h3>
            </div>
            <div :class="['card__skills', 'content', {showInfo: isInfo}]">

                <div :class="['content', {showInfo: isInfo}]">
                    <div v-for="(value, key) in nextCall.extra" :key="key">
                        {{ key }}: {{ value}}
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
import {mapGetters} from 'vuex';
const socket = io.connect("https://" + location.hostname + ":3002/");

export default {
        data(){
            return {
                extension: user.getExtension(),
                runningCampaign: [],
                nextCall: {},
                timer: 0,
                interval: {},
                isInfo: false,
                controlDOM: {
                    logged: false,
                    inPause: false
                },
                inCall: false,
            }
        },
        computed:{
			...mapGetters(
				[
					'getCampanha',
				]
			)
        },
        watch:{
            nextCall: function(){
                if(!this.nextCall == {})
                    return;

            },

            timer: function(){
                if(this.timer <= 0){
                    this.ligar(this.nextCall.telefone);
                }
            },
            runningCampaign: function(){
                if(this.nextCall.telefone)
                    return;

                if(this.getCampanha && this.runningCampaign){
                    this.getNewClient();
                }
            },
            inCall: function(){
                if(this.inCall)
                    this.stopTime();
            }
        },
        methods: {
            parse_obj(data){
                return {
                    nome: data.name,
                    telefone: data.phone,
                    telefone_2: data.phone_2,
                    extra: {
                        nome: data.name,
                        telefone: data.phone,
                        telefone_2: data.phone_2,
                    }

                }
            },
            ligar(tel) {

                let phone = tel.replace( /^\D+/g, '');
                this.stopTime();
                socket.emit('Originate', {
                    calltype: 'outgoing',
                    extension: this.extension,
                    phone: phone
                });

            },
            info(){
                this.isInfo = !this.isInfo;
            },
            getTime(){
                return new Date(this.timer * 1000).toISOString().substr(11, 8)
            },
            startTime(){
                this.interval = setInterval(() => {
                    if(this.inCall) this.stopTime();
                    if(!this.controlDOM.logged) this.stopTime();
                    if(this.controlDOM.inPause) this.stopTime();

                    console.log("timer: ", this.timer, this.controlDOM);

                    this.timer--;
                }, 1000);
            },
            stopTime(){
                this.timer = 30;
                clearInterval(this.interval);
            },
            getNewClient(){
                this.stopTime();
                this.nextCall = {};

                if(this.runningCampaign.length == 0){
                    return;
                }
                console.log("executei rsrs");
                axios.post('/set_campaigns', { id: this.runningCampaign }).then(data => {
                    this.nextCall = this.parse_obj(data.data[0]);
                    this.startTime();
                });
            },
            listenEvents: function(){

                socket.on(`CoreShowChannel-${this.extension}`, data => this.inCall = true );
                socket.on(`NewConnectedLine-${this.extension}`, data => this.stopTime() );

                socket.on(`Hangup-${this.extension}`, data => {
                    this.inCall = false;
                    if(!this.controlDOM.logged) return;
                    let num = this.nextCall.telefone.replace( /^\D+/g, '');
                    let sub_num = (num.length == 8) ? num : num.substr(num.length - 9, 8)

                    let patt = `/(.+?${num})|(${num})|(.+?${sub_num})|(${sub_num})/`;
                    let caller = data.CallerIDNum.replace( /^\D+/g, '');

                    // Comparar se a ligação encerrada é o mesmo do numero da minha campanha
                    if(caller.match(patt)){
                        this.getNewClient();
                        return;
                    }

                    // Confere se existe telefone 2 e aplica mesma expressão regular
                    if(this.nextCall.telefone_2){
                        num = this.nextCall.telefone_2.replace( /^\D+/g, '');
                        sub_num = (num.length == 8) ? num : num.substr(num.length - 9, 8)
                        patt = `/(.+?${num})|(${num})|(.+?${sub_num})|(${sub_num})/`;

                        if(caller.match(patt)){
                            this.getNewClient();
                            return;
                        }
                    }
                    this.startTime();
                });

                socket.on(`QueueMember-${this.extension}`, data => {
                    if(!this.getQueues.includes(data.Queue)){
                        return;
                    }
                    if(this.controlDOM.logged) return;
                    this.controlDOM.logged = true;
                    if(data.Paused == 1){
                        this.controlDOM.inPause = true;
                        console.log("entrei aqui");
                        this.stopTime();
                        return;
                    }
                    this.getNewClient();
                });

                socket.on(`QueueMemberPause-${this.extension}`, data => {
                    console.log("QueueMemberPause-campanha");
                    // Entrou em pausa
                    if(data.Paused == 1){
                        if(this.controlDOM.inPause) return;
                        this.stopTime();
                        this.controlDOM.inPause = true;
                    }

                    // Saiu da pausa
                    if(data.Paused == 0){
                        if(!this.controlDOM.inPause) return;
                        this.controlDOM.inPause = false;
                        if(this.nextCall.telefone){
                            console.log("queuememberpause");
                            this.startTime();
                        } else {
                            this.getNewClient();
                        }
                    }
                });

                socket.on(`QueueMemberAdded-${this.extension}`, data => {
                    if(this.controlDOM.logged) return;
                    this.getNewClient();
                    this.controlDOM.logged = true;
                });
                socket.on(`QueueMemberRemoved-${this.extension}`, data => {
                    if(!this.controlDOM.logged) return;
                    this.stopTime();
                    this.controlDOM.logged = false;
                });
            }


        },
        created(){
            this.listenEvents();

            axios.get('/at_campaigns').then(data => {

                if(data.data)
                    this.runningCampaign = data.data;

            });
        }
}
</script>

<style scoped>

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
  background-color: #1F618D;
}

.card__container {
    position: absolute;
    width: 320px;
    margin: 15px auto;
    padding: 20px 0 0;
    text-align: center;
    background-color: #1c869a;
    color: white;
    border-radius: 5px;
    box-shadow: 0px 10px 20px -10px rgba(0,0,0,0.75);
    float: right;
    margin-right: 3em;
    right: 0;
    width: calc(25% - 4em);
}

.card__container .pro {
    position: absolute;
    background-color: #FEBB0B;
    color: #231E39;
    border-radius: 3px;
    font-size: 14px;
    padding: 3px 7px;
    top: 20px;
    left: 30px;
}

.card__img {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    padding: 7px;
    border: 1px solid #03BFCB;
}

h3 {
    margin: 5px 0;
}

h6 {
    margin: 5px 0;
}

p {
    margin: 5px 0;
    line-height: 30px;
}

.card__button button {
    width: 100px;
    height: 30px;
    border: 1px solid #03BFCB;
    color: #03BFCB;
    background-color: transparent;
    border-radius: 0.25em !important;
}

.card__button button:hover {
    background-color: #03BFCB;
    color: #231E39;
}

.card__skills {
    margin: 15px 0 0;
    background-color: #186473;
    padding: 10px 10px;
}

.card__skills h6 {
    font-size: 16px;
    margin-bottom: 10px;
}

.card__skills a {
    padding: 7px;
    color: #B3B8CD;
    border: 1px solid grey;
    text-decoration: none;
}


.content {
  padding: 0 18px;
  display: none;
  overflow: hidden;
  transition: height 4s;
}
.infoClicked{

    transform: rotate(180deg);
    transition: 0.3s;
}
.showInfo {
    display:block;
    transition: height 4s;
}

.info-pointer{
    float: right;
    position: absolute;
    right: 15px;
    cursor: pointer;
    transition: 0.3s;
}

.call{
 cursor: pointer;
}
.call >>> i{
    font-size: 0.8em;
}

.call:hover{
    color:black;
}

.contatos{
    display: flex;
    justify-content: center;
}
.contatos >>> .call:first-child{
    margin-right: 15px;
}

@media (max-width: 1398px) {
	.card__container {
		margin-right: 2.5em;
	}

	h3 {
    	font-size: 1.4em;
	}
}
</style>
